import * as React from "react";
import PropTypes from "prop-types";
import {
  Button,
  DialogTitle,
  DialogContent,
  DialogActions,
  Dialog,
  TextField,
  Stack,
  Typography
} from "@mui/material";

export default function LineupServiceMoveToActionModal({
  modalOpened,
  onClose,
  moveSomewhereSelectedServicesTest,
  currentLineupParams,
  selectedServicesIds
}) {
  const [idxTarget, setIdxTarget] = React.useState("");
  const [errorHelperText, setErrorHelperText] = React.useState("");
  const inputRef = React.useRef(null);

  const handleEntered = () => {
    if (inputRef.current != null) {
      inputRef.current.focus();
    }
  };

  const handleCancel = () => {
    onClose();
  };

  const handleConfirm = () => {
    if (!Number.isNaN(idxTarget) && idxTarget >= 0) {
      setErrorHelperText("");
      setIdxTarget("");
      moveSomewhereSelectedServicesTest(currentLineupParams, selectedServicesIds, Number(idxTarget));
      onClose();
    } else {
      setErrorHelperText("LCN should be 0 or a positive integer");
    }
  };

  return (
    <Dialog
      TransitionProps={{ onEntered: handleEntered }}
      open={modalOpened}
    >
      <DialogTitle>Move selected service(s)</DialogTitle>
      <DialogContent dividers>
        <Stack spacing={1}>
          <Typography>
            Please enter the first LCN where to move selection :
          </Typography>
          <TextField
            inputRef= {inputRef}
            value={idxTarget}
            onChange={event => {
              setIdxTarget(event.target.value);
            }}
            error={errorHelperText.length > 0}
            helperText={errorHelperText}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel}>
          Cancel
        </Button>
        <Button onClick={handleConfirm}>Confirm</Button>
      </DialogActions>
    </Dialog>
  );
}

LineupServiceMoveToActionModal.defaultProps = {
  modalOpened: false,
  onClose: null,
  moveSomewhereSelectedServicesTest: null,
  currentLineupParams: null,
  selectedServicesIds: [],
};

LineupServiceMoveToActionModal.propTypes = {
  modalOpened: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  moveSomewhereSelectedServicesTest: PropTypes.func.isRequired,
  currentLineupParams: PropTypes.object,
  selectedServicesIds: PropTypes.arrayOf(PropTypes.number),
};
